import {useQuery} from 'react-query';
import getLikedPosts from '.';

const useGetLikedPosts = () => {
  const {data, isLoading} = useQuery(['liked-posts'], () => getLikedPosts());

  return {data, isLoading};
};

export default useGetLikedPosts;
